import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import Image from "./Image";
import Link from "next/link";
import PropTypes from "prop-types";
import Quote from "./Quote";
import React from "react";
import Text from "./Text";
import Ticker from "./Ticker";

function BrandsPageHero({
  heading,
  imageDesktop,
  imageMobile,
  brands,
  quote,
  quoteSource,
  quoteImage,
}) {
  return (
    <Box bg="yellow" pt={[100, null, 120, null]} pb={[60, null, 120, null]}>
      <BoxWithGutter pb={[40, null, 60, null]}>
        <Text
          as="h1"
          uppercase
          fontSize={[26, 26, 62, 62]}
          lineHeight={["32px", "32px", 1, 1]}
          dangerouslySetInnerHTML={{ __html: heading }}
        />
      </BoxWithGutter>
      <Box height={["80vw", "29.76vw", null, null]} position="relative">
        <Image
          src={imageDesktop.url}
          alt={imageDesktop.title}
          height="100%"
          width="100%"
          position="absolute"
          top={0}
          left={0}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["none", "initial", null, null]}
          bg="lightGrey"
        />
        <Image
          src={imageMobile.url}
          alt={imageMobile.title}
          height="100%"
          width="100%"
          position="absolute"
          top={0}
          left={0}
          objectFit="cover"
          objectPosition="50% 0%"
          display={["initial", "none", null, null]}
          bg="lightGrey"
        />
      </Box>
      <Ticker
        tickerItem={
          <div className="brand-ticker-item">
            {brands.map((brand) => {
              if (brand.slug) {
                const href = `/${brand.slug}`;
                return (
                  <Link key={brand.name} href={href}>
                    {brand.name}
                  </Link>
                );
              } else {
                return <span key={brand.name}>{brand.name}</span>;
              }
            })}
          </div>
        }
        bg="black"
        height={60}
      />
      <BoxWithGutter pt={[30, null, "5.95vw", null]}>
        <Quote
          quote={quote}
          quoteSource={quoteSource}
          quoteImage={quoteImage}
        />
      </BoxWithGutter>
    </Box>
  );
}

export default BrandsPageHero;

BrandsPageHero.propTypes = {
  heading: PropTypes.string.isRequired,
  imageDesktop: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  imageMobile: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  brands: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string,
    })
  ).isRequired,
  quote: PropTypes.string.isRequired,
  quoteSource: PropTypes.string.isRequired,
  quoteImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};
